import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import get from 'lodash/get';
import { compose } from 'redux';
import { L, List, ConfirmModal, Loader, Icon, Button } from 'nallian-shared-ui/lib/components';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { history } from 'nallian-shared-ui/lib/config/history';
import { FetchHandlerModule } from 'nallian-shared-ui/lib/modules';
// import { formatDateTime } from 'nallian-shared-ui/lib/lib/dateTime';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';
import deleteAccessRightService from '../../accessRights/services/deleteAccessRightService';
import accessRightStatesService from '../../accessRights/services/accessRightStatesService';
import { VEHICLE_SIDEBAR_ACTIONS } from './VehicleSidebar';

class VehicleAccessRightsOverview extends PureComponent {
  state = {
    accessRightsLoading: [],
  };

  handleDeleteAccessRight = accessRightId => {
    this.setState(prevState => ({
      accessRightsLoading: [...prevState.accessRightsLoading, accessRightId],
    }));
    this.props.dispatchDeleteAccessRightDelete(
      accessRightId,
      () =>
        this.setState(prevState => ({
          accessRightsLoading: prevState.accessRightsLoading.filter(
            loadingId => accessRightId !== loadingId
          ),
        })),
      this.props.vehicleId
    );
  };

  componentDidUpdate(prevProps) {
    const { vehicleId, dispatchGet } = this.props;
    if (vehicleId && vehicleId !== prevProps.vehicleId) {
      dispatchGet(vehicleId);
      this.props.dispatchAccessRightStatesGet();
    }
  }
  componentWillMount() {
    const { vehicleId } = this.props;
    if (vehicleId) {
      this.props.dispatchGet(vehicleId);
      this.props.dispatchAccessRightStatesGet();
    }
  }

  render() {
    const {
      fetch,
      accessRightStatesFetch,
      baseUrl,
      t,
      noEdit,
      showOnPremiseOrganisation,
      organisationId,
      noAdd,
    } = this.props;
    return (
      <FetchHandlerModule fetches={[fetch, accessRightStatesFetch]}>
        <List divided relaxed clearing>
          {fetch.pending && (
            <L.Item>
              <Loader inline="centered" active />
            </L.Item>
          )}
          {fetch.fulfilled && fetch.value.values.length === 0 && (
            <Fragment>
              <L.Item>{t('noAccessRights')}</L.Item>
              {!noAdd && (
                <HasRight right="access-rights/create">
                  <Button
                    icon="add"
                    fluid
                    content={t('addAccessRight')}
                    onClick={() =>
                      history.push(
                        `${baseUrl}/${VEHICLE_SIDEBAR_ACTIONS.NEW_ACCESS_RIGHT}${document.location.search}`,
                        {
                          goBack: true,
                        }
                      )
                    }
                  />
                </HasRight>
              )}
            </Fragment>
          )}
          {fetch.fulfilled &&
            fetch.value.values.length > 0 &&
            fetch.value.values.map(accessRight => {
              const loading = this.state.accessRightsLoading.indexOf(accessRight.id) > -1;
              return (
                <L.Item key={accessRight.id}>
                  <L.Content floated="right">
                    <Loader active={loading} inline size="mini" />
                    {!loading && (
                      <Fragment>
                        <HasRight right="access-rights/update">
                          {!noEdit && (
                            <Icon
                              name="pencil"
                              link
                              title={t('editAccessRight')}
                              onClick={() => {
                                history.push(
                                  `${baseUrl}/${VEHICLE_SIDEBAR_ACTIONS.EDIT_ACCESS_RIGHT}/${accessRight.id}${document.location.search}`,
                                  { goBack: true }
                                );
                              }}
                            />
                          )}
                        </HasRight>
                        <HasRight right="access-rights/delete">
                          {organisationId === accessRight.onPremiseOrganisationId && (
                            <ConfirmModal
                              header={t('deleteAccessRightConfirmation')}
                              cancelContent={t('cancel')}
                              confirmContent={t('delete')}
                              confirmIcon="trash"
                              confirmColor="red"
                              onConfirm={() => this.handleDeleteAccessRight(accessRight.id)}
                              trigger={<Icon name="trash" link title={t('deleteAccessRight')} />}
                            />
                          )}
                        </HasRight>
                      </Fragment>
                    )}
                  </L.Content>
                  <L.Header>
                    {' '}
                    {get(
                      find(accessRightStatesFetch.value, { id: accessRight.stateId }),
                      'name',
                      '...'
                    )}
                  </L.Header>
                  <L.Description>
                    {/* {formatDateTime(accessRight.validFrom)}
                    <br />
                    {formatDateTime(accessRight.validUntil)} */}
                    {showOnPremiseOrganisation && (
                      <p>
                        <b>{t('approver')}</b>
                        <br />
                        {accessRight.onPremiseOrganisationName}
                      </p>
                    )}
                    {/* <p>
                      <b>{t('owner')}</b>
                      <br />
                      {accessRight.offPremiseOrganisationName}
                    </p> */}
                  </L.Description>
                </L.Item>
              );
            })}
        </List>
      </FetchHandlerModule>
    );
  }
}

VehicleAccessRightsOverview.propTypes = {
  t: PropTypes.func.isRequired,
  dispatchGet: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
  dispatchDeleteAccessRightDelete: PropTypes.func.isRequired,
  dispatchAccessRightStatesGet: PropTypes.func.isRequired,
  accessRightStatesFetch: PropTypes.object.isRequired,
  vehicleId: PropTypes.string,
  showOnPremiseOrganisation: PropTypes.bool,
  baseUrl: PropTypes.string.isRequired,
  organisationId: PropTypes.string.isRequired,
  noEdit: PropTypes.bool,
  noAdd: PropTypes.bool,
};

VehicleAccessRightsOverview.defaultProps = {
  vehicleId: undefined,
  noEdit: false,
  showOnPremiseOrganisation: false,
  noAdd: false,
};

const mapStateToProps = state => ({
  organisationId: GetOrganisationId(state),
});

export default compose(
  connect(mapStateToProps),
  withTranslation(),
  deleteAccessRightService,
  accessRightStatesService
)(VehicleAccessRightsOverview);
